module.exports = __webpack_public_path__ + "static/media/tv.2885eda8.png";